// LICENSE_CODE ZON
'use strict'; /*jslint node:true, browser:true*/
(function(){
var define;
var is_node = typeof module=='object' && module.exports;
if (!is_node)
    define = self.define;
else
    define = require('../../../util/require_node.js').define(module, '../');
define(['/util/date.js', 'lodash4'],
    function(date, _){
var assign = Object.assign;
var E = {};

E.is_service_active = function(c, status){
    return (status||c.status)=='active'; };

E.is_active = function(c){
    return c.status=='active'; };

E.is_disabled = function(c){
    return c.status=='disabled'; };

E.is_suspended = function(c){
    return {suspended: 1, suspend_manual: 1}[c.status]; };

E.is_suspended_auto = function(c){
    return c.status=='suspended'; };

E.is_suspended_manual = function(c){
    return c.status=='suspend_manual'; };

E.is_temporary = function(c){
    var cname = c==null || typeof c=='string' ? c : c.name;
    return /^hl_[0-9a-f]{6}/.test(cname||'');
};

E.is_internal = function(c){
    return c.is_fake || c.is_demo; };

E.is_paid = function(c){
    return !!c.paid; };

E.is_paid_or_promo = function(c){
    return !!(c.paid||c.onboarding_bonus); };

E.get_managers = function(c, opt){
    opt = opt||{};
    var managers = _.flatten([c.owner||[], c.leadgen||[]]);
    if (opt.login_only)
        managers = managers.map(function(m){ return m.split('@').shift(); });
    return _.uniq(managers).filter(Boolean);
};

E.get_customer_managers = function(c){
    return {owner: c&&c.owner||[], leadgen: c&&c.leadgen||[]};
};

E.is_managed_by = function(c, mgr){
    return E.get_managers(c).includes(mgr); };

// -- misc --

E.is_correct_name = function(name){
    return /^[a-z0-9_]{2,}$/.test(name); };

E.name_errors = function(name, context){
    context = context||{};
    var errors = [];
    if (!E.is_correct_name(name))
        errors.push('contains invalid characters');
    if (name.length>15)
        errors.push('should not be more than 15 characters');
    var duplication = name.match(/([a-z]{3,})\1/);
    var domain_matches = duplication && (context.domains||[])
    .filter(function(d){ return d.includes(duplication[0]); }).length;
    if (duplication && !domain_matches)
        errors.push("should not have repeating pattern '"+duplication[0]+"'");
    return errors;
};

// -- date sequence utils --

// opt:
//   no_add - don't push item to sequence;
//   in_place - update sequence object as well;
E.add_to_date_sequence = function(sequence, item, field, opt){
    opt = opt||{};
    if (opt.in_place && !Array.isArray(sequence))
        throw new Error('No input array to modify');
    if (!item || !item.start)
        throw new Error('Wrong item to insert');
    var upd_idx, next_idx, update = {}, i, pull;
    if (sequence && sequence.length)
    {
        for (i=sequence.length-1; i>=0; i--)
        {
            if (date(sequence[i].start)<date(item.start))
            {
                if (!sequence[i].end ||
                    date(sequence[i].end)>=date(item.start))
                {
                    upd_idx = i;
                }
                next_idx = i+1;
                break;
            }
            else if (+date(sequence[i].start)==+date(item.start))
            {
                next_idx = i;
                if (i>0 && (!sequence[i-1].end ||
                    +sequence[i-1].end==+date(item.start)))
                {
                    upd_idx = i-1;
                }
                break;
            }
            else
                next_idx = i;
        }
        if (upd_idx>=0 && sequence[upd_idx].end &&
            date(sequence[upd_idx].end)>date(item.start))
        {
            update.$unset = update.$unset||{};
            update.$unset[field+'.'+upd_idx+'.end'] = 1;
            if (opt.in_place)
                delete sequence[upd_idx].end;
        }
        if (!opt.no_add)
        {
            update.$set = update.$set||{};
            update.$set[field+'.'+next_idx] = item;
            if (opt.in_place)
                sequence[next_idx] = item;
        }
        else
            next_idx--;
        if (next_idx<sequence.length-1)
        {
            update.$unset = update.$unset||{};
            for (i=next_idx+1; i<sequence.length; i++)
                update.$unset[field+'.'+i] = 1;
            pull = {};
            pull[field] = null;
            if (opt.in_place)
                sequence.splice(next_idx+1);
        }
    }
    else
    {
        update.$push = update.$push||{};
        update.$push[field] = item;
        if (opt.in_place)
            sequence.push(item);
    }
    return pull ? [update, {$pull: pull}] : Object.keys(update).length ?
        update : undefined;
};

E.merge_date_sequence_update = function(updates){
    var update = [], i;
    if (!updates || !updates.length)
        return update;
    var merge_updates = function(u1, u2){
        if (!u2 || !Object.keys(u2).length)
            return;
        var fields = ['$set', '$unset', '$push', '$pull'];
        fields.forEach(function(f){
            if (u2[f])
            {
                u1[f] = u1[f]||{};
                assign(u1[f], u2[f]);
            }
        });
    };
    for (i=0; i<updates.length; i++)
    {
        update[0] = update[0]||{};
        if (Array.isArray(updates[i]))
        {
            update[1] = update[1]||{};
            merge_updates(update[0], updates[i][0]);
            merge_updates(update[1], updates[i][1]);
        }
        else
        {
            merge_updates(update[0], updates[i]);
        }
    }
    return update.filter(function(u){ return u && Object.keys(u).length>0; });
};

E.sort_sequence_update = function(update){
    var ret = [];
    var fields = ['$set', '$unset', '$push', '$pull'];
    update.forEach(function(u){
        fields.forEach(function(f){
            if (u[f])
            {
                var op = {};
                op[f] = u[f];
                ret.push(op);
            }
        });
    });
    return ret;
};

return E; }); }());
